module.exports = __webpack_public_path__ + "img/logo.c5dbbd68.webp";